import { SIGNPOST_SIGN, DISTANCE_TYPE } from '../enums/route.enum';
import { ILatLng } from 'src/app/core/models/google-map-models';
import { RouteDirection } from './route-direction-model';

export class GeoBearing {
  constructor() {}

  private radians(n) {
    return n * (Math.PI / 180);
  }
  private degrees(n) {
    return n * (180 / Math.PI);
  }

  public getBearing(startLat, startLong, endLat, endLong) {
    startLat = this.radians(startLat);
    startLong = this.radians(startLong);
    endLat = this.radians(endLat);
    endLong = this.radians(endLong);

    let dLong = endLong - startLong;

    const dPhi = Math.log(Math.tan(endLat / 2.0 + Math.PI / 4.0) / Math.tan(startLat / 2.0 + Math.PI / 4.0));
    if (Math.abs(dLong) > Math.PI) {
      if (dLong > 0.0) {
         dLong = -(2.0 * Math.PI - dLong);
      } else {
         dLong = (2.0 * Math.PI + dLong);
      }
    }

    return (this.degrees(Math.atan2(dLong, dPhi)) + 360.0) % 360.0;
  }
}


export class RouteSignpostList {
  RouteSignpost: Array<RouteSignposts> = [];

  addRoute(route: RouteSignposts) {
    this.RouteSignpost.push( route );
  }

  reset(): void {
    this.RouteSignpost = [];
  }

  setDistanceType(distanceType: DISTANCE_TYPE) {
    this.RouteSignpost.forEach( routeSignpost => {
      routeSignpost.DistanceType = distanceType;
    });
    this.updateDistance();
  }

  updateDistance() {
    let beginDistanceFrom = 0;
    this.RouteSignpost.forEach( routeSignpost => {
      beginDistanceFrom = routeSignpost.updateDistance(beginDistanceFrom);
    });
  }

  updateDuration() {
    let totalDuration = 0;
    this.RouteSignpost.forEach( routeSignpost => {
      totalDuration = routeSignpost.updateDuration(totalDuration);
    });
  }
}

export class RouteSignposts extends RouteDirection {
    Name: string;
    StartRouteLeg: RouteLeg = new RouteLeg();
    EndRouteLeg: RouteLeg = new RouteLeg();
    RouteLegs: Array<RouteLeg> = [];

    SectionDuration: any;
    TotalDuration: any;

    constructor(name: string) {
      super();
      this.Name = name;
    }

    hideAllMap() {
      this.RouteLegs.forEach( direction => {
        direction.showGoogleMap = false;
      });
    }

    addRouteDirection(routeLegs, previousRouteLeg) {
        const routeLeg: RouteLeg = new RouteLeg(routeLegs);
        routeLeg.Name = this.Name + '_routeName' +  this.RouteLegs.length;
        this.RouteLegs.push( routeLeg );
        routeLeg.previousDirectionDistance = (previousRouteLeg) ? previousRouteLeg.distanceValue : 0;

        return routeLeg;
    }

    updateDuration(totalWith: number): number {
      this.TotalDuration = totalWith + this.SectionDuration;
      return this.TotalDuration;
    }

    durationToPrint() {
      return `Section time: ${ this.timeConversion(this.SectionDuration * this.ToKm, true)},
              Total time: ${ this.timeConversion(this.TotalDuration * this.ToKm, true) }`;
    }

    updateDistance(beginDistanceFrom?: number): number {
      let endDistance = beginDistanceFrom;

      this.StartRouteLeg.Distance = (endDistance / this.getDistanceFormat() ).toFixed(1);
      this.RouteLegs.forEach( routeLeg => {
          routeLeg.Distance = (endDistance / this.getDistanceFormat() ).toFixed(1);
          routeLeg.formatedDistanceValue = (routeLeg.previousDirectionDistance / this.getDistanceFormat() ).toFixed(1);

          endDistance = endDistance + routeLeg.distanceValue;
      });

      this.EndRouteLeg.formatedDistanceValue = (this.EndRouteLeg.distanceValue / this.getDistanceFormat() ).toFixed(1);
      this.EndRouteLeg.Distance = (endDistance / this.getDistanceFormat() ).toFixed(1);

      return endDistance;
    }
  }

  export class MemberBenefits {
    address: any;
    lat: number;
    lon: number;
    partner: any;
    brandLogo: any;
    benefitOffers: Array<any>;
  }

  export class RouteLeg extends GeoBearing {
    Name: string;
    Summary: string;
    Road: Array<Road> = [];
    Distance: any;
    Type: SIGNPOST_SIGN;
    MemberBenefits: MemberBenefits;
    leg: any;
    Prefix: any;
    Suffix: any;
    distanceValue: number;
    previousDirectionDistance: number;
    formatedDistanceValue: any;

    endLocation: ILatLng;
    showGoogleMap: boolean;

    constructor(leg?: any) {
      super();
      if (leg) {
        this.leg = leg;
        this.Summary = leg.instructions;
        this.Distance = leg.distance.text;
        this.distanceValue = leg.distance.value;

        this.location = {lat: leg.start_location.lat(), lng: leg.start_location.lng()};
        this.endLocation = {lat: leg.end_location.lat(), lng: leg.end_location.lng()};
      }
    }

    get headingDegrees() {
      const heading = this.getBearing(this.location.lat, this.location.lng, this.endLocation.lat, this.endLocation.lng);
      return Math.round(heading);
    }

    private _latLng: ILatLng;
    set location(value) {
      this._latLng = value;
    }
    get location(): ILatLng {
      return this._latLng;
    }

  }

  export class Road {
    Name: Array<string> = [];
    Text: Array<string> = [];
    Type: SIGNPOST_SIGN = SIGNPOST_SIGN.HOSPITAL_SIGN;
    Icon: String;
    Suffix: Array<string> = [];
    Prefix: Array<string> = [];

    constructor(type: SIGNPOST_SIGN) {
      // console.log('suffix',this)
        this.Type = type;
    }
  }

  // Request Models
  export namespace RequestModel {
    export class MemberBenefitModel {
        distanceKm: number;
        namedPoints: Array<MemberBenefitItemModel>;
      }

      export class MemberBenefitItemModel {
        name: string;
        lat: number;
        lon: number;

        constructor(name: string, lat: number, lon: number) {
          this.name = name;
          this.lat = lat;
          this.lon = lon;
        }
      }

      export class SignpostsRequestModel {
        distanceKm: number;
        namedPoints: Array<RoadRequestModel>;
      }

      export class RoadRequestModel {
        headingDegrees: number;
        lat: number;
        lon: number;
        name: string;
        hints: Array<string> = [];

        constructor(name: string, lat: number, lon: number, degree: number) {
          this.name = name;
          this.lat = lat;
          this.lon = lon;
          this.headingDegrees = degree;
        }

        setHints(summary: string) {
          const $element: Element = document.createElement('div');
          $element.innerHTML = summary;

          const BTagList: HTMLCollection = $element.getElementsByTagName('B');
          if (BTagList.length > 0) {
            for (let index = 0; index < BTagList.length; index++) {
              this.hints.push( BTagList[index].innerHTML );
            }
          }
        }
      }
  }


